import React from 'react'

import { Error } from '../errors'

export const ProtectionPayment = ({ children, permission = null }) => {
  return permission !== 'suspended' ? children : <Error.Payment />
}
